import React from 'react';
import { render } from 'react-dom';
import { Router, Route, browserHistory, IndexRoute } from 'react-router';
import App from '../modules/common/layout';
import index from '../modules/index';
import login from '../modules/login';
import logs from '../modules/logs';
import users from '../modules/users';
import patients from '../modules/patients';
import register from '../modules/register';
import defaultValues from '../modules/defaultValues';
import doctorSummary from '../modules/doctorSummary';
import patientSummary from '../modules/patientSummary';
import doctorAdvice from '../modules/doctorAdvice';
import deviceInfo from '../modules/deviceInfo';
import chat from '../modules/chat';
import chatFixedPatient from '../modules/chatFixedPatient';
import notFound from '../modules/notFound';
import noAuthorization from '../modules/noAuthorization';
import notSupported from '../modules/notSupported';
import forgotPassword from '../modules/forgotPassword';
import updatePassword from '../modules/updatePassword';
import OTP from '../modules/OTP';
import banned from '../modules/banned';
import enums from '../config/enums';
import axios from 'axios';
var browser = require('detect-browser');

var userTypeID = 0;
var user = {};

function requireCredentials(nextState, replace, next) {
    var isBrowserApproved = true;
    // if (browser) {
    //     if ((browser.name == "chrome" && browser.version >= "50") || (browser.name == "explorer" && browser.version >= "11")) {
    //         isBrowserApproved = true;
    //     }
    // }

    if (!isBrowserApproved) {
        replace("/notSupported");
        next();
    }
    else {
        serverAuth().then(() => {
            if (nextState.routes[1].authorization.indexOf(userTypeID) != -1)
                next();
            else {
                if (nextState.location.pathname.indexOf("/noAuthorization") == -1)
                    replace("/noAuthorization"); next();
            }
        }, () => {
            replace('/login?prevUrl=' + nextState.location.pathname)
            next()
        })
    }
}

function checkRedirect(nextState, replace, next) {
    if (user.IsPasswordChangeNeeded) {
        replace("/edit?m=changePass"); next();
    }
    else if (user == null) {
        console.log("here2");
        replace("/noAuthorization"); next();
    }
    nextState.params["userTypeID"] = user.UserTypeID;
    nextState.params["user"] = user;
    next();
}

function checkCredentials(nextState, replace, next) {
    serverAuth().then(() => { replace('/'); next() },
        (reason) => {
            if (reason == "banned")
                replace("/banned");
            next()
        });
}

function serverAuth() {
    return new Promise((resolve, reject) => {
        axios
            .get("/data/getConnectedUser")
            .then(function (data) {
                if (data.data == "banned") {
                    reject("banned");
                }
                if (data.data != null) {
                    user = data.data;
                    userTypeID = data.data.UserTypeID;
                    resolve('authenticated');
                } else {
                    reject('nope');
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    });
}

render((
    <Router history={browserHistory}>
        <Route path="" component={App} onEnter={requireCredentials} userTypeID={userTypeID} >
            <Route path="/" component={index} onEnter={checkRedirect} userTypeID={userTypeID} authorization={[enums.USER_TYPE.DOCTOR, enums.USER_TYPE.SUPER, enums.USER_TYPE.IT]} />
            <Route path="/doctor/:userID" component={doctorSummary} onEnter={checkRedirect} authorization={[enums.USER_TYPE.SUPER, enums.USER_TYPE.IT]} />
            <Route path="/logs" component={logs} onEnter={checkRedirect} userTypeID={userTypeID} authorization={[enums.USER_TYPE.DOCTOR, enums.USER_TYPE.SUPER, enums.USER_TYPE.IT]} />
            <Route path="/users" component={users} onEnter={checkRedirect} authorization={[enums.USER_TYPE.SUPER, enums.USER_TYPE.IT]} />
            <Route path="/patients" component={patients} onEnter={checkRedirect} userTypeID={userTypeID} authorization={[enums.USER_TYPE.DOCTOR, enums.USER_TYPE.SUPER, enums.USER_TYPE.IT]} />
            <Route path="/patient/:userID" component={patientSummary} onEnter={checkRedirect} authorization={[enums.USER_TYPE.DOCTOR, enums.USER_TYPE.SUPER, enums.USER_TYPE.IT]} />
            {/* <Route path="/defaultValues" component={defaultValues} onEnter={checkRedirect} authorization={[enums.USER_TYPE.SUPER]} /> */}
            <Route path="/register" component={register} onEnter={checkRedirect} status='new' authorization={[enums.USER_TYPE.IT]} />
            <Route path="/edit" component={register} status='edit' userTypeID={userTypeID} authorization={[enums.USER_TYPE.DOCTOR, enums.USER_TYPE.SUPER, enums.USER_TYPE.IT]} />
            <Route path="/edit/:userID" component={register} onEnter={checkRedirect} status='edit' authorization={[enums.USER_TYPE.DOCTOR, enums.USER_TYPE.SUPER, enums.USER_TYPE.IT]} />
            <Route path="/profile/:userID" component={register} onEnter={checkRedirect} status='show' authorization={[enums.USER_TYPE.DOCTOR, enums.USER_TYPE.SUPER, enums.USER_TYPE.IT]} />
            <Route path="/doctorAdvice/:userID" component={doctorAdvice} onEnter={checkRedirect} authorization={[enums.USER_TYPE.DOCTOR, enums.USER_TYPE.SUPER, enums.USER_TYPE.IT]} />
            <Route path="/devices" component={deviceInfo} onEnter={checkRedirect} authorization={[enums.USER_TYPE.IT]} />
            <Route path="/noAuthorization" component={noAuthorization} authorization={[enums.USER_TYPE.DOCTOR, enums.USER_TYPE.SUPER, enums.USER_TYPE.IT]} />
            <Route path='/chat/:userID' component={chat} onEnter={checkRedirect} authorization={[enums.USER_TYPE.DOCTOR, enums.USER_TYPE.SUPER, enums.USER_TYPE.IT]} />
            <Route path='/chatFixedPatient' component={chatFixedPatient} onEnter={checkRedirect} authorization={[enums.USER_TYPE.DOCTOR, enums.USER_TYPE.SUPER, enums.USER_TYPE.IT]} />
        </Route>
        <Route path="/login" component={login} onEnter={checkCredentials} />
        <Route path="/OTP" component={OTP} />
        <Route path="/banned" component={banned} />
        <Route path="/notSupported" component={notSupported} />
        <Route path="/forgotPassword" component={forgotPassword} />
        <Route path="/updatePassword" component={updatePassword} />


        <Route path='*' component={notFound} />
    </Router>
), document.getElementById('app'))


// WEBPACK FOOTER //
// ./client/app.js